<template>
    <div
        class="absolute inset-0 flex flex-col items-center justify-center gap-4 z-10 w-full h-full bg-gradient-to-b from-white/0 via-white/70 to-white/90 dark:from-slate-800/0 dark:via-slate-800/70 dark:to-slate-800/90"
    >
        <div class="flex flex-col items-center gap-1">
            <div class="flex justify-center items-center pb-1">
                <Icon
                    icon="lock"
                    class="text-orange"
                    :width="28"
                    :height="28"
                />
            </div>
            <span
                class="text-slate-800 dark:text-slate-100 font-inter text-lg font-medium leading-7"
            >
                {{ title }}
            </span>
            <span
                class="text-slate-500 dark:text-slate-400 font-inter text-sm font-normal leading-5"
            >
                Available with 10xTravel+
            </span>
        </div>
        <button
            type="button"
            class="flex items-center justify-center gap-2 px-4 py-2 rounded bg-[#FD421D] shadow-sm text-white font-inter text-sm font-medium leading-5"
            @click="openUpgrade"
        >
            Upgrade
        </button>
        <!-- </div> -->
    </div>
</template>

<script setup>
import { useCardBenefitsStore } from '@/store/card-benefits';
import Icon from '@/components/ui/icon/icon.vue';

defineProps({
    title: {
        type: String,
        default: 'Unlock benefits usage',
    },
});

const store = useCardBenefitsStore();

const openUpgrade = () => {
    store.setShowUpgradeModal(true);
};
</script>
